<template>
  <div>
    <div class="investigation-call-log__bar">
      <select
        class="ds-field investigation-call-log__stages"
        :value="stageFilter || ''"
        data-qa="investigation-stage-filter"
        aria-label="Filter op stap"
        @change="$emit('update:stageFilter', $event.target.value || null)"
      >
        <option value="">Alle stappen ({{ calls.length }} calls)</option>
        <option v-for="stage in stages" :key="stage" :value="stage">{{ stage }}</option>
      </select>

      <label class="ds-toggle">
        <input
          :checked="onlyFailed"
          type="checkbox"
          data-qa="investigation-only-failed-toggle"
          @change="$emit('update:onlyFailed', $event.target.checked)"
        />
        <span class="ds-toggle__track"></span>
        <span class="ds-toggle__label">Alleen mislukte calls</span>
      </label>

      <span class="investigation-call-log__spacer"></span>

      <button
        type="button"
        class="ds-button ds-button--ghost ds-button--sm"
        data-qa="investigation-expand-all"
        @click="expandAll"
      >
        Alles uitklappen
      </button>
      <button
        type="button"
        class="ds-button ds-button--ghost ds-button--sm"
        data-qa="investigation-collapse-all"
        @click="$emit('update:openCallIds', {})"
      >
        Alles inklappen
      </button>
    </div>

    <p v-if="!visibleCalls.length" class="investigation-call-log__note">
      Geen calls voor deze selectie.
    </p>
    <template v-else>
      <investigation-call
        v-for="call in visibleCalls"
        :key="call.id"
        :call="call"
        :open="!!openCallIds[call.id]"
        @toggle="toggle(call.id)"
      />
    </template>
  </div>
</template>

<script>
import InvestigationCall from './InvestigationCall.vue'
import { isFailedCall } from './investigationFormat'

// The full call log: every request the investigation made, filterable by stage
// and by outcome.
//
// Which calls are expanded, and both filters, are owned by the page rather than by this component:
// the findings panel opens a specific call by id, and it has to be able to clear a filter that
// would otherwise hide the very call it just opened.

export default {
  name: 'InvestigationCallLog',
  components: { InvestigationCall },
  props: {
    calls: {
      type: Array,
      default: () => [],
    },
    stageFilter: {
      type: String,
      default: null,
    },
    openCallIds: {
      type: Object,
      default: () => ({}),
    },
    onlyFailed: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:stageFilter', 'update:openCallIds', 'update:onlyFailed'],
  computed: {
    stages() {
      return [...new Set(this.calls.map((call) => call.stage))]
    },
    visibleCalls() {
      return this.calls.filter((call) => {
        if (this.stageFilter && call.stage !== this.stageFilter) return false
        return !this.onlyFailed || isFailedCall(call)
      })
    },
  },
  methods: {
    toggle(id) {
      this.$emit('update:openCallIds', { ...this.openCallIds, [id]: !this.openCallIds[id] })
    },
    expandAll() {
      const open = { ...this.openCallIds }
      this.visibleCalls.forEach((call) => {
        open[call.id] = true
      })
      this.$emit('update:openCallIds', open)
    },
  },
}
</script>

<style lang="scss" scoped>
.investigation-call-log {
  &__bar {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
    margin-bottom: var(--ds-space-3);
  }

  &__stages {
    width: auto;
    min-width: 220px;
  }

  &__spacer {
    flex: 1;
  }

  &__note {
    margin: 0;
    padding: 18px 22px;
    font-size: var(--ds-font-size-base);
    font-style: italic;
    color: var(--ds-color-text-subtle);
  }
}
</style>
